import {type} from 'arktype'

export const Stats = type({
  total_results: 'number | null',
  result_count: 'number | null',
  page_size: 'number | null',
  total_hits: 'number | null',
})

export const Pager = type({
  total_pages: 'number | null',
  current_page: 'number | null',
})

export const CrumbList = type({
  facet_id: 'string | null',
  facet_name: 'string | null',
  facet_value: 'string | null',
  hidden: 'boolean | null',
})

export const BreadCrumb = type({
  crumb_list: [CrumbList.array(), '|', 'null'],
  query_text: 'string | null',
  selected_location: 'string | null',
  current_sort: 'string | null',
  override_sort: 'null | undefined',
  sort_direction: 'string | null',
  location_mode: 'string | null',
  radius: 'string | null',
})

export const Sort = type({
  sort_id: 'string | null',
  field: 'string | null',
  pretty_name: 'string | null',
  fragment: 'string | null',
})

export const Range = type({
  start: 'string|null',
  end: 'string|null',
})

export const Image = type({
  base_url: 'string | null',
  public_id: 'string | null',
  format: 'string | null',
  tag: 'string | null',
  source: 'null | undefined',
  scale_mode: 'null | undefined',
})

export const Value = type({
  'value': 'string | null',
  'count': 'number | null',
  'link_fragment': 'string | null',
  'range?': Range,
  'selected': 'boolean | null',
  'child_facet_value_list': 'null | undefined',
  'image?': Image,
})

export const FacetList = type({
  id: 'string | null',
  name: 'string | null',
  values: [Value.array(), '|', 'null'],
  style: 'string | null',
  multi: 'boolean | null',
  hidden: 'boolean | null',
  sequence: 'number | null',
  slider_config: 'null | undefined',
  group: 'null | undefined',
  additional_values: 'boolean | null',
})

export const CountOmittingOpenTimes = type({
  count: 'number | null',
  enabled: 'boolean',
})

export const SearchMetricsProps = type({
  id: 'string | null',
  value: 'number | null',
})

export const SearchMetrics = type({
  'searchMetrics-catering': SearchMetricsProps,
  'searchMetrics-pickup': SearchMetricsProps,
})

export const MarketContext = type({
  market_size: 'string | null',
  geohash: 'string | null',
  adjusted_reasons: 'string[] | null',
})

export const QueryExpansionContext = type({
  original: 'string | null',
  query_expansion: 'null | undefined',
  type: 'string | null',
})

export const IntentSearchContext = type({
  analysisType: 'string | null',
  analysisValue: 'string | null',
  analysisSource: 'string | null',
})

export const TabList = type({
  full_display: 'string | null',
  link_fragment: 'string | null',
  selected: 'boolean | null',
  short_display: 'string | null',
})

export const CacheKeys = type({})

export const CacheContext = type({
  cacheKeys: [CacheKeys.array(), '|', 'null'],
  restoredFromCache: 'boolean | null',
})

export const RestaurantFilterSponsoredResult = type({})

export const SponsoredResult = type({
  search_sponsored_id: 'string | null',
  stats: Stats,
  results: [RestaurantFilterSponsoredResult.array(), '|', 'null'],
})

export const ModelOutputs = type({})

export const DcpResponseInfo = type({
  flow_name: 'string | null',
  group_name: 'string | null',
  model_outputs: ModelOutputs,
})

export const FacetBaseLinks = type({})
export const RestaurantFilterSearchResult = type({})
export const ModelInputList = type({})

export const SearchResult = type({
  stats: Stats,
  pager: Pager,
  bread_crumb: BreadCrumb,
  sorts: [Sort.array(), '|', 'null'],
  facet_list: [FacetList.array(), '|', 'null'],
  facet_base_links: FacetBaseLinks,
  results: [RestaurantFilterSearchResult.array(), '|', 'null'],
  count_omitting_open_times: CountOmittingOpenTimes,
  search_metrics: SearchMetrics,
  market_context: MarketContext,
  rewrite_context: 'null | undefined',
  query_expansion_context: QueryExpansionContext,
  intent_search_context: IntentSearchContext,
  tab_list: [TabList.array(), '|', 'null'],
  model_input_list: [ModelInputList.array(), '|', 'null'],
  cache_context: CacheContext,
})

export const SuggestedSearches = type({})
export const FavoriteRestaurants = type({})

export const RestaurantFilter = type({
  search_id: 'string | null',
  search_result: SearchResult,
  sponsored_result: SponsoredResult,
  variation_ids: 'string[] | null',
  search_metrics: 'null | undefined',
  dcp_response_info: DcpResponseInfo,
  suggested_searches: [SuggestedSearches.array(), '|', 'null'],
  restaurant_not_in_platform: 'boolean | undefined',
  restaurant_not_in_platform_object: 'null | undefined',
  favorite_restaurants: [FavoriteRestaurants.array(), '|', 'null'],
})

export const RestaurantFilterProps = type({
  orderMethod: 'string | null | undefined',
  locationMode: 'string | null | undefined',
  facetSet: 'string | null | undefined',
  pageSize: 'number | null | undefined',
  hideHateos: 'boolean',
  searchMetrics: 'boolean',
  queryText: 'string | null | undefined|null',
  location: 'string | null | undefined',
  preciseLocation: 'boolean',
  geohash: 'string | null | undefined',
  includeOffers: 'boolean',
  sortSetId: 'string | null | undefined',
  countOmittingTimes: 'boolean',
})

export type RestaurantFilterProps = typeof RestaurantFilterProps.infer
